import React, { useState } from "react";
import PageTitleBanner from "../../Components/Reusable/PageTitleBanner";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import Image from "../../Components/Reusable/Image";
import CustomDropDownReward from "../../Components/Reusable/CustomDropDownReward";

const BharatSatScholarship = () => {
  // add new code
  const [activeStandard, setActiveStandard] = useState('Standard 10');

  const handleStandardClick = (standard) => {
    setActiveStandard(standard);
  };

  const handleLevelClick = (level) => {
    setActiveLevel(level);
  };

  const getRewardsForLevel = (standard) => {
    return standardRewards[standard]?.rewards || [];
  };

  const getTalukaRewardsForLevel = (standard) => {
    return standardRewards[standard]?.talukaRewards || [];
  };

  const getExamFee = () => {
    return standardRewards[activeStandard]?.examFee || 'N/A';
  };

  const standards = Object.keys(standardRewards);


  return (
    <div className="d-flex flex-column mb-auto">
      <PageTitleBanner PageTitle={"Encouraging Brilliance with the Bharat SAT Scholarship Program"} breadCrumpPageTitle={"Bharat SAT Scholarship"} />
      <div className="text-content-page-container d-flex flex-column align-items-center mb-0">
        <div className='bharat-sat-text-image-container d-flex flex-column gap-3 align-items-center container p-0'>
          <h2 className='Heading headingColor mb-0 fw-600 text-center'>Empowering Minds, Celebrating Excellence</h2>
          <p className='medium-text subTextColor mb-0 text-center'>Welcome to the Bharat SAT Examination, an extraordinary national-level initiative spanning 300 carefully chosen districts, where internet connectivity thrives. Our mission extends far beyond assessment – we're dedicated to recognizing and honoring academic brilliance while empowering the brightest minds across our nation.</p>
        </div>

        <div className='bharat-sat-text-image-container d-flex flex-column gap-4 align-items-center container p-0 mt-4'>
          <h2 className='Heading headingColor mb-0 fw-600 text-center'>Scholarship Distribution</h2>

          <div className="col-md-12 row g-3">
            <div className="col-md-12">
              <div className="coordinator-text-content-card" style={{ backgroundColor: "#BFEAFF" }}>
                <div className="coordinator-rewards-container d-flex gap-4 align-items-center rewards-district-level-container">
                  <Image className="coordinator-rewards-image rewards-district-level-image" src={PngImages.rewardsDistrictLevel} style={{ height: 150, marginLeft: -36 }} />
                  <div className="d-flex flex-column gap-2">
                    <h3 className="large-text fw-600 darkBlueColor mb-0">District-Level Recognition</h3>
                    <p className="medium-text fw-400 black mb-0 mt-2">
                      In each of the 300 districts, we celebrate the top 10 achievers across grades 5 to 10 with prestigious Scholarships. This means 60 at each district level and additional 2 at each Taluka level exceptional scholars in every district! The total grant in each district amounts to a remarkable.</p>
                    <p className="medium-text fw-400 black mb-0 mt-2">
                      INR 1000000 ensuring a minimum participation of 1500 students from each grade. Nationally, this equates to a staggering 18000 and additional 2 in each Taluka level scholarships, fostering healthy competition and fair opportunities for success.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="coordinator-text-content-card" style={{ backgroundColor: "#FFE8E8" }}>
                <h3 className="large-text fw-600 darkBlueColor mb-0">
                  Nationwide Commitment
                </h3>
                <p className="medium-text fw-400 black mb-0 mt-2">
                  Total Scholarship Fund: Bharat SAT proudly announces a substantial commitment of Rs. 25 Crores at the national level. This financial support is dedicated to nurturing and encouraging the educational pursuits of the brightest young minds throughout the country.                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="coordinator-text-content-card" style={{ backgroundColor: "#DCFFD3" }}>
                <h3 className="large-text fw-600 darkBlueColor mb-0">
                  Nurturing Excellence, Unlocking Potential
                </h3>
                <p className="medium-text fw-400 black mb-0 mt-2">
                  Academic excellence is paramount, and our scholarships aim to pave the way for deserving students to chase their dreams. These rewards signify more than just financial aid; they represent our unwavering dedication to fostering talent, promoting a culture of learning, and championing the aspirations of our youth.                </p>
              </div>
            </div>
          </div>

          <p className="medium-text fw-400 black mb-0 mt-3 text-center">
            At Learn and Achieve Edutech, we firmly believe that acknowledging and rewarding merit is pivotal in sculpting a brighter future for our nation. The Bharat SAT Examination's rewards program is a testament to our commitment to nurturing talent and supporting academic achievement, both at the district and national levels. Join us in celebrating brilliance and shaping a prosperous tomorrow!          </p>
        </div>

        <div className="bharat-sat-text-image-container container mt-5 p-0 pt-4">
          <div className="position-relative reward-price-card coordinator-text-content-card">
            <div className="coordinator-rewards-container d-flex gap-4 align-items-center">
              <Image className="rewards-price-trophy" src={PngImages.rewardsTrophy} style={{ height: 250 }} />
              <div className="d-flex flex-column gap-1" style={{ zIndex: 2 }}>
                <h3 className="sub-large-text fw-600 black mb-0">
                  Transforming Education, Empowering Futures Welcome to the Bharat SAT Scholarship Program!
                </h3>
                <p className="Sub-Heading fw-400 mb-0 mt-2" style={{ color: "#212121" }}>We are proud to introduce what is likely the biggest private scholarship initiative in India.</p>
                <p className="Sub-Heading fw-400 mb-0 mt-0" style={{ color: "#212121" }}>This year, we are distributing an impressive Rs. 250,000,000 to support more than 60,000 brilliant students nationwide.</p>
              </div>
              <Image className="reward-achievement-card-background" src={SvgImages.rewardAchievementCardBackground} />
            </div>
          </div>
        </div>
      </div>

      {/* reward section */}
      <div className="bharat-sat-benefits greyBackground w-100 d-flex flex-column reward-container-mobile overflow-hidden">
        <div className="d-flex flex-column container gap-4 reward-container-mobile p-0">
          <h2 className='Heading headingColor fw-600 text-center rewardDistrictHeading'>Rewards and Scholarships</h2>
          {/* <div className="reward-tabs-section d-flex justify-content-between">
            <div className="d-flex gap-3 align-items-center tabs-left">
              <h1 className="large-text headingColor mb-0 fw-600  ">Lorem Ipsum dummy</h1>
            </div>
            <div className="d-flex gap-3 align-items-center tabs-right">
              <h2 className="Sub-Heading fw-600 black mb-0 exam-date">Exam Date : Nov 24th 2024</h2>
              <div className="Exam-Fee-btn">
                <h2 className="mb-0 fw-600 white">Exam Fee : {getExamFee()}</h2>
              </div>
            </div>
          </div> */}

          <div className="d-flex gap-3 reward-rank-mobile align-items-start">
            <div className="w-100 standards-dropdown mt-4">
              <CustomDropDownReward
                labelTitle=""
                id="standard"
                name="standard"
                placeholder="Select standard"
                options={standards?.map((standard) => ({ value: standard, label: standard }))}
                defaultOption={() => {
                  return { value: activeStandard, label: activeStandard }
                }}
                onChange={(selectedOption) => handleStandardClick(selectedOption.value)}
              />
            </div>

            <div className="reward-Standard-card">
              <div className="d-flex align-items-center flex-column gap-3 mx-0">
                {standards.map(standard => (
                  <div
                    key={standard}
                    className={`d-flex gap-3 align-items-center standard-item cursor-pointer ${activeStandard === standard ? 'active' : ''}`}
                    onClick={() => setActiveStandard(standard)}
                  >
                    <Image className="align-self-start" src={SvgImages.rewardRankMedal} style={{ height: 76, marginBottom: -40, opacity: (standard === activeStandard ? 1 : 0) }} />
                    <h3 className={`mb-0 large-text fw-600 ${(standard === activeStandard ? "white" : "black")} py-3`}>{standard}</h3>
                  </div>
                ))}
              </div>
            </div>

            <div className=" w-100">
              <h2 className="large-text mb-0 fw-600 border-top pt-4 orangeAccentColor">District
                level</h2>
              <div className="reward-rank-card w-100">

                {getRewardsForLevel(activeStandard).map(rank => (
                  <div key={rank.rank} className="rank-card p-3 d-flex flex-column gap-3">
                    <Image src={SvgImages.rewardRankTrophy} style={{ width: 31 }} />
                    <h2 className="mb-0 fw-600 black">Rank {rank.rank} :</h2>
                    <h3 className="mb-0 fw-600 blue">{rank.amount}</h3>
                  </div>
                ))}

              </div>
              <h2 className="large-text mb-0 fw-600  pt-4 orangeAccentColor">Taluka
                level</h2>
              <div className="reward-rank-card w-100 border-0"  >
                {getTalukaRewardsForLevel(activeStandard).map(rank => (
                  <div key={rank.rank} className="rank-card p-3 d-flex flex-column gap-3">
                    <Image src={SvgImages.rewardRankTrophy} style={{ width: 31 }} />
                    <h2 className="mb-0 fw-600 black">Rank {rank.rank} :</h2>
                    <h3 className="mb-0 fw-600 blue">{rank.amount}</h3>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default BharatSatScholarship;

const standardRewards = {
  'Standard 10': {
    rewards: [
      { rank: 1, amount: '₹ 50,000' },
      { rank: 2, amount: '₹ 35,000' },
      { rank: 3, amount: '₹ 30,000' }, // Same amount as rank 2
      { rank: 4, amount: '₹ 25,000' }, // Same amount as rank 2
      { rank: 5, amount: '₹ 20,000' }, // Same amount as rank 2
      { rank: 6, amount: '₹ 15,000' }, // Same amount as rank 2
      { rank: 7, amount: '₹ 12,500' }, // Same amount as rank 2
      { rank: 8, amount: '₹ 10,000' }, // Same amount as rank 2
      { rank: 9, amount: '₹ 7,500' }, // Same amount as rank 2
      { rank: 10, amount: '₹ 7,500' }, // Same amount as rank 2
      // Add rewards for Standard 10 ranks
    ],
    talukaRewards: [
      { rank: 1, amount: '₹ 3,000' },
      { rank: 2, amount: '₹ 2,000' },
    ],
    examFee: '₹ 950',
    talukaFee: '₹ 950',
  },
  'Standard 9': {
    rewards: [
      { rank: 1, amount: '₹ 50,000' },
      { rank: 2, amount: '₹ 35,000' },
      { rank: 3, amount: '₹ 30,000' }, // Same amount as rank 2
      { rank: 4, amount: '₹ 25,000' }, // Same amount as rank 2
      { rank: 5, amount: '₹ 20,000' }, // Same amount as rank 2
      { rank: 6, amount: '₹ 15,000' }, // Same amount as rank 2
      { rank: 7, amount: '₹ 12,500' }, // Same amount as rank 2
      { rank: 8, amount: '₹ 10,000' }, // Same amount as rank 2
      { rank: 9, amount: '₹ 7,500' }, // Same amount as rank 2
      { rank: 10, amount: '₹ 7,500' }, // Same amount as rank 2
      // Add rewards for Standard 10 ranks
    ],
    talukaRewards: [
      { rank: 1, amount: '₹ 3,000' },
      { rank: 2, amount: '₹ 2,000' },
    ],
    examFee: '₹ 950',
    talukaFee: '₹ 950',
  },
  'Standard 8': {
    rewards: [
      { rank: 1, amount: '₹ 35,000' },
      { rank: 2, amount: '₹ 30,000' },
      { rank: 3, amount: '₹ 25,000' }, // Same amount as rank 2
      { rank: 4, amount: '₹ 20,000' }, // Same amount as rank 2
      { rank: 5, amount: '₹ 15,000' }, // Same amount as rank 2
      { rank: 6, amount: '₹ 12,500' }, // Same amount as rank 2
      { rank: 7, amount: '₹ 10,000' }, // Same amount as rank 2
      { rank: 8, amount: '₹ 7,500' }, // Same amount as rank 2
      { rank: 9, amount: '₹ 5,000' }, // Same amount as rank 2
      { rank: 10, amount: '₹ 5,000' }, // Same amount as rank 2
    ],
    talukaRewards: [
      { rank: 1, amount: '₹ 3,000' },
      { rank: 2, amount: '₹ 2,000' },
    ],
    examFee: '₹ 850',
    talukaFee: '₹ 850'
  },
  'Standard 7': {
    rewards: [
      { rank: 1, amount: '₹ 35,000' },
      { rank: 2, amount: '₹ 30,000' },
      { rank: 3, amount: '₹ 25,000' }, // Same amount as rank 2
      { rank: 4, amount: '₹ 20,000' }, // Same amount as rank 2
      { rank: 5, amount: '₹ 15,000' }, // Same amount as rank 2
      { rank: 6, amount: '₹ 12,500' }, // Same amount as rank 2
      { rank: 7, amount: '₹ 10,000' }, // Same amount as rank 2
      { rank: 8, amount: '₹ 7,500' }, // Same amount as rank 2
      { rank: 9, amount: '₹ 5,000' }, // Same amount as rank 2
      { rank: 10, amount: '₹ 5,000' }, // Same amount as rank 2
    ],
    talukaRewards: [
      { rank: 1, amount: '₹ 3,000' },
      { rank: 2, amount: '₹ 2,000' },
    ],
    examFee: '₹ 850',
    talukaFee: '₹ 850',
  },
 'Standard 6': {
    rewards: [
      { rank: 1, amount: '₹ 20,000' },
      { rank: 2, amount: '₹ 17,500' },
      { rank: 3, amount: '₹ 15,000' }, // Same amount as rank 2
      { rank: 4, amount: '₹ 12,500' }, // Same amount as rank 2
      { rank: 5, amount: '₹ 10,000' }, // Same amount as rank 2
      { rank: 6, amount: '₹ 7,500' }, // Same amount as rank 2
      { rank: 7, amount: '₹ 5,000' }, // Same amount as rank 2
      { rank: 8, amount: '₹ 4,000' }, // Same amount as rank 2
      { rank: 9, amount: '₹ 3,000' }, // Same amount as rank 2
      { rank: 10, amount: '₹ 3,000' }, // Same amount as rank 2
    ],
    talukaRewards: [
      { rank: 1, amount: '₹ 2,000' },
      { rank: 2, amount: '₹ 1,500' },
    ],
    examFee: '₹ 650',
    talukaFee: '₹ 650'
  },
  'Standard 5': {
    rewards: [
      { rank: 1, amount: '₹ 20,000' },
      { rank: 2, amount: '₹ 17,500' },
      { rank: 3, amount: '₹ 15,000' }, // Same amount as rank 2
      { rank: 4, amount: '₹ 12,500' }, // Same amount as rank 2
      { rank: 5, amount: '₹ 10,000' }, // Same amount as rank 2
      { rank: 6, amount: '₹ 7,500' }, // Same amount as rank 2
      { rank: 7, amount: '₹ 5,000' }, // Same amount as rank 2
      { rank: 8, amount: '₹ 4,000' }, // Same amount as rank 2
      { rank: 9, amount: '₹ 3,000' }, // Same amount as rank 2
      { rank: 10, amount: '₹ 3,000' }, // Same amount as rank 2
    ],
    talukaRewards: [
      { rank: 1, amount: '₹ 2,000' },
      { rank: 2, amount: '₹ 1,500' },
    ],
    examFee: '₹ 650',
    talukaFee: '₹ 650',
  },
  // Define rewards for other standards similarly
};